import React, { useEffect } from "react";
import { Layout } from "antd";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logoImage from "../assets/images/logo-white.png";
import search from "../assets/images/search.png";

import { Content, Footer, Header } from "antd/lib/layout/layout";
import { ProtocolProvider } from "../providers/ProtocolContext";
import MenuLang from "../components/Menus/MenuLang";
import MenuAdmin from "../components/Menus/MenuAdmin";
import { translate } from "../locale";
import PropTypes from "prop-types";

const terms_url = process.env.REACT_APP_TERMS_OF_USE;
const privacy_url = process.env.REACT_APP_PRIVACY_POLICY;

const AdminLayout = ({ onLogout }) => {
  const location = useLocation();
  const paths = ["/admin/error404"];

  useEffect(() => {
    if (!paths.includes(location.pathname)) {
      sessionStorage.setItem("nextUrl", location.pathname);
    }
  }, [location]);

  return (
    <Layout className="bg-white" style={{ minHeight: "100vh" }}>
      <Header className="h-16 bg-custom_primary">
        <div className="max-w-7xl mx-auto h-16 flex flex-row items-center">
          <div className="flex flex-1 flex-row">
            <div className="flex items-center">
              <Link to="/admin">
                <img src={logoImage} className="h-8" />
              </Link>
            </div>
            <div className="ml-6 hidden md:block">
              <Link
                to="/admin/buscar-paciente"
                className="mx-2 text-xl text-white hover:text-black"
              >
                <img src={search} className="h-8" />
              </Link>
            </div>
          </div>
          <div>
            <MenuLang />
            <MenuAdmin onLogout={onLogout} />
          </div>
        </div>
      </Header>
      <Content className="flex flex-1 justify-center items-start">
        <ProtocolProvider>
          <Outlet />
        </ProtocolProvider>
      </Content>
      <Footer className="h-auto bg-custom_primary py-10">
        <div className="max-w-7xl mx-auto flex flex-row items-center">
          <div className="hidden md:flex flex-1">
            <img src={logoImage} className="h-8" alt="Adium" />
          </div>
          <div className="flex-1 flex justify-center gap-4">
            <a
              href={terms_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row items-center text-white hover:!text-gray-300 hover:underline"
            >
              {translate("Términos de uso")}
            </a>
            <span className="text-white">|</span>
            <a
              href={privacy_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row items-center text-white hover:!text-gray-300 hover:underline"
            >
              {translate("Políticas de privacidad y seguridad")}
            </a>
          </div>
          <div className="hidden md:flex flex-1"></div>
        </div>
      </Footer>
    </Layout>
  );
};

AdminLayout.propTypes = {
  onLogout: PropTypes.func,
};

export default AdminLayout;
